// extracted by mini-css-extract-plugin
export default {"otherSettings":"VkhK","title":"l6+p","divider":"zzbF"};